import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import MerchandiseOfferCarousel from 'components/Merchandise/MerchandiseCarousels/MerchandiseOfferCarousel'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import { getMerchandiseCategorySearchUrl } from 'components/Merchandise/merchandiseUtils'

const GOLF_CATEGORY_SLUG = 'golf'
const GOLF_TRACKING_PAGE_NAME = 'Golf Campaign Page'
const GOLF_TRACKING_LIST_NAME = 'Tee Off in Style with Premium Golf Essentials'
function GolfMerchandiseCategoryCarousel() {
  const golfCarouselTitle = <FormattedMessage
    id="u98Nkjad1Nr-L4qLy8sk"
    defaultMessage="Tee Off in Style with <italic>Premium Golf Essentials</italic>"
    
    values={{
      italic: (chunks) => <i>{chunks}</i>,
    }}
  />

  const [category] = useMerchandiseCategory({ slug: GOLF_CATEGORY_SLUG })

  const filters = useMemo<App.MerchandiseFilters | undefined>(() => {
    if (!category) { return undefined }
    return {
      categories: [category.id],
    }
  }, [category])

  const viewAllTo = useMemo<string | undefined>(() => {
    if (!category) { return undefined }
    return getMerchandiseCategorySearchUrl(category)
  }, [category])

  return <>
    {!!category && !!filters && !!viewAllTo && (
      <MerchandiseOfferCarousel
        title={golfCarouselTitle}
        filters={filters}
        viewAllTo={viewAllTo}
        trackingListName={GOLF_TRACKING_LIST_NAME}
        trackingPageName={GOLF_TRACKING_PAGE_NAME}
      />
    )}
  </>
}

export default GolfMerchandiseCategoryCarousel
